<script>
    import Button from 'views/components/button/Button.svelte'
    import Modal from 'views/components/modals/Modal.svelte'
    import LearnbeatAppUtil from 'util/LearnbeatAppUtil';
    import Util from 'util/util';

    function openDownloadLink() {
        const isWindows = window.UAParser.os.is('Windows');
        const isMac = window.UAParser.os.is('macOS') && !Util.hasSupportForTouch();

        let url = 'https://support.learnbeat.nl/article/dyvgfi03pd-werken-met-learnbeat-focus';
        if (isWindows) {
            url = 'https://apps.microsoft.com/detail/9NTKH7CHH9H1';
        } else if (isMac) {
            url = 'https://apps.apple.com/nl/app/learnbeat/id6785441432?mt=12';
        }

        window.open(url, '_blank')
    }
</script>

<Modal title={window.i18n.gettext('Your teacher activated the focus mode')} closeOnRoute={false}>

    <div class="body-text">{window.i18n.gettext('Focus mode is only available in the app. Open Learnbeat in the app to continue.')}</div>

    <svelte:fragment slot="buttons">
        <Button
            label={window.i18n.gettext('Download app')}
            theme="secondary"
            callback={openDownloadLink}>
        </Button>
        <Button
            label={window.i18n.gettext('Open app')}
            callback={() => LearnbeatAppUtil.onClickOpenInApp(false)}>
        </Button>
    </svelte:fragment>

</Modal>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.body-text {
  font-size: 16px;
}</style>
